// GeneralReports.js
import React, { useState } from "react";
import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";
import { Row, Col } from "react-bootstrap";
import Constants from "../../../../common/Constants";
import ItemService from "../../../../services/commonService";
import { toastFunc } from "../../../../components/common/util";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Button from "react-bootstrap/Button";
import moment from "moment";
import Loader from "../../../../common/Loader";
import TableRenderers from "react-pivottable/TableRenderers";
import DatePicker from "react-widgets/DatePicker";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { AlertModal } from "../../../common/AlertModal";
import ProdStatusFilterBox from "../../../../components/common/ProdStatusFilterBox";

const GeneralReports = () => {
  // eslint-disable-next-line no-unused-vars
  const [monthData, setReportMonthData] = useState(null);
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [value, setValue] = useState();
  const [isAlert, setIsAlert] = useState(false);
  const [alertValue, setAlertValue] = useState("");
  const [displayFilter, setDisplayFilter] = useState(false);

  const [pivotState, setPivotState] = useState({
    data: [],
    rows: ["SizeCode", "Customer", "Jobcard"], // 'CurrentDate',
    cols: ["Departments", "Status", "Reason"],
    aggregatorName: "Integer Sum",
    vals: ["Quantity"],

    // sorters: pivotSorters, // 🧠 override sort behavior here
  });
  const { t } = useTranslation();
  const customRenderers = {
    Table: TableRenderers["Table"], // 👈 keep only this
  };
  const resetAlert = () => {
    setIsAlert(false);
  };
  const loadPivotList = async (filter) => {
    const allowedFilterKeys = [
      "jobcard",
      "customer",
      "plan",
      "sizeCode",
      "getStatus",
      "planType",
      "required_date_from",
      "required_date_to",
    ];

    const cleanFilter = {};
    allowedFilterKeys.forEach((key) => {
      if (
        filter &&
        filter[key] !== undefined &&
        filter[key] !== null &&
        filter[key] !== ""
      ) {
        cleanFilter[key] = filter[key];
      }
    });

    try {
      let param = {
        url: "getPivoteTable",
        page: Constants.TRANSACTION.ORDERCONFIRMATION.name,
        headers: [
          "SizeCode",
          "CurrentDate",
          "Jobcard",
          "Departments",
          "Status",
          "Reason",
          "Quantity",
          "jobcardStatus",
          "Customer",
        ],
        monthData: monthData,
        dropdownValue: value,
        filter:cleanFilter
      };
      await ItemService.getTransactionListDataById(param).then((item) => {
        // if (item?.status === 200) {
        setLoaderStatus(false);
        setPivotState({
          data: item.data,
          rows: ["SizeCode", "Customer", "Jobcard"], // 'CurrentDate',
          cols: ["Departments", "Status", "Reason"],
          aggregatorName: "Integer Sum",
          vals: ["Quantity"],

          // sorters: pivotSorters, // 🧠 override sort behavior here
        });
        // } else {
        //     console.log(">> Error: Loading getApplicationMaster");
        // }
      });
    } catch (error) {
      console.error("Error in handleStartStopSuccess:", error);
      toastFunc(
        Constants.MASTER.TOAST.error,
        "Somthing went wrong while fetching data.",
        4000
      );
    }
  };

  const searchGeneralReport = (filter) => {
    if (!value) {
      setIsAlert(true);
      setAlertValue("Please Select Status.");
    } else if (value === "Completed" && monthData === null) {
      setIsAlert(true);
      setAlertValue("Please Select Month and year to view Completed Records.");
    } else {
      setLoaderStatus(false); // reset
      setTimeout(() => {
        setLoaderStatus(true);
        loadPivotList(filter);
      }, 0); // slight delay to allow state to register
    }
  };

  const exportToExcel = () => {
    const table = document.querySelector(".pvtTable"); // react-pivottable renders this class
    if (!table) {
      alert("No pivot table rendered!");
      return;
    }

    const exportTable = table.cloneNode(true);
    exportTable.querySelectorAll("th, td").forEach((cell) => {
      const value = cell.textContent.trim();
      if (/^.+_\d+_\d+$/.test(value)) {
        cell.textContent = value.replace(/_\d+_\d+$/, "");
      }
    });

    const workbook = XLSX.utils.table_to_book(exportTable, {
      sheet: "Pivot Table",
    });
    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      "masterReport.xlsx"
    );
  };

  const searchData = async (searchObj) => {
    console.log(">> searchObj", searchObj);

    searchGeneralReport(searchObj);
  };

  const resetSearch = (page) => {
    searchGeneralReport();
  };

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={4} md={4} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {"General Reports - "}{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {monthData
                  ? moment(monthData).format("MMM-YYYY")
                  : moment().format("MMM-YYYY")}
              </span>
            </h2>
            <p className="subText">{"Operators Report details page"}</p>
          </div>
        </Col>
        <Col xs={2} md={2} className="">
          <DropdownListField
            id="code"
            name="name"
            className="dropdownHive w-full rounded-md"
            data={["InProcess", "Completed"]}
            value={value}
            onChange={(value) => {
              setValue(value);
              if (value === "InProcess") {
                setReportMonthData(null);
              }
            }}
            placeholder={"Please Select Status"}
            autoFocus={true}
            // disabled={props?.data?.category === "ADMIN" ? true : false}
            // error={roleError}
          />
        </Col>
        <Col xs={2} md={2} className="px-4">
          <DatePicker
            parse={["MMM yyyy"]}
            max={new Date()}
            required
            onChange={(e) => {
              setReportMonthData(moment(e).format("YYYY-MM-DD"));
            }}
            valueFormat={{ month: "short", year: "numeric" }}
            calendarProps={{ views: ["year", "decade", "century"] }}
            disabled={value === "InProcess" ? true : false}
          />
        </Col>
        <Col xs={1} md={1} className="">
          <Button
            type="button"
            variant="success"
            size="lg"
            className="btn btn-primary searchFilter-btn"
            onClick={searchGeneralReport}
            disabled={loaderStatus}
          >
            {" "}
            <i className="bi bi-search"></i>
          </Button>
        </Col>
        <Col xs={1} md={1} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i className="bi bi-filter"> </i>
          </Button>
        </Col>
        <Col xs={2} md={2} className="rightSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={exportToExcel}
          >
            {" "}
            {"Download Excel"}
          </Button>
        </Col>
        <hr />
      </Row>

      <div className="pivot-wrapper">
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <Loader isLoading={loaderStatus} className={"text-center"} />
        </div>
        {displayFilter && (
          <Row className="reportheader">
            <Col xs={12} md={12} className="leftSide">
              <ProdStatusFilterBox
                searchData={searchData}
                deptOptionReq={false}
                jobcardStatusReq={true}
                customer={true}
                required_date={true}
                plan={true}
                planType={true}
                handleDownload={searchData}
                resetFilerBox={setDisplayFilter}
                resetSearch={resetSearch}
                exportBtn={false}
                // pageName={props.pageName}
              ></ProdStatusFilterBox>
            </Col>
          </Row>
        )}
        {pivotState.data && pivotState.data.length > 0 && (
          <PivotTableUI
            {...pivotState}
            tableOptions={{
              rowTotals: false,
              colTotals: false,
            }}
            renderers={customRenderers}
            onChange={(s) => {
              setPivotState(s);
            }}
          />
        )}
      </div>
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={alertValue}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </main>
  );
};

export default GeneralReports;
